export const UPDATE_CONTENT_FILTERS = '[ACTION] UPDATE_CONTENT_FILTERS';

export function returnObjectForContentFiltersUpdate(filters: any) {
	return {
		type: UPDATE_CONTENT_FILTERS,
		payload: { filters },
	};
}
